import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type IncidentReportSocketUpdateAction =
  | 'CREATED'
  | 'UPDATED'
  | 'SUBMITTED'
  | 'DELETED'
  | 'ATTACHMENT_ADDED'
  | 'ATTACHMENT_DELETED';

export type IncidentReportSocketUpdatePayload = {
  siteId: string;

  action: IncidentReportSocketUpdateAction;

  reportId: string;
};

type IncidentReportRealtimeState = {
  versionBySite: Record<string, number>;

  lastUpdate: IncidentReportSocketUpdatePayload | null;
};

const initialState: IncidentReportRealtimeState = {
  versionBySite: {},

  lastUpdate: null,
};

const incidentReportSlice = createSlice({
  name: 'incidentReport',

  initialState,

  reducers: {
    incidentReportSocketUpdateReceived(
      state,

      action: PayloadAction<IncidentReportSocketUpdatePayload>
    ) {
      const payload = action.payload;

      if (!payload?.siteId) {
        return;
      }

      state.versionBySite[payload.siteId] =
        (state.versionBySite[payload.siteId] ?? 0) + 1;

      state.lastUpdate = payload;
    },
  },
});

export const { incidentReportSocketUpdateReceived } =
  incidentReportSlice.actions;

export default incidentReportSlice.reducer;
